import React, { useState } from "react";
import PageSeo from "../components/PageSeo";
import { Helmet } from "react-helmet-async";

export default function BudgetPlanner() {
  const [salary, setSalary] = useState("");
  const [down, setDown] = useState("");
  const [result, setResult] = useState(null);

  const calculate = () => {
    const s = Number(salary);
    const d = Number(down);

    if (!s) return;

    const eligible = s * 20 + d;
    setResult(Math.round(eligible));
  };

  const shareOnWhatsApp = () => {
    const text = encodeURIComponent(`Check my calculation result: ${result} | MotoHub India https://motohubindia.com`);
    const url = window.innerWidth < 768 
      ? `whatsapp://send?text=${text}` 
      : `https://web.whatsapp.com/send?text=${text}`;
    window.open(url, '_blank');
  };

  const downloadPDF = () => {
    const el = document.getElementById('calculator-result');
    const original = document.title;
    document.title = 'MotoHub-Calculation-Result';
    window.print();
    document.title = original;
  };

  return (
    <>
      <PageSeo
        title="Bike Budget Planner India | Check Affordable Bike Price | MotoHub India"
        description="Calculate how much bike you can afford based on your salary and down payment. Use MotoHub India budget planner to choose the right motorcycle in India."
        keywords={[
          "bike budget planner India",
          "affordable bike calculator",
          "bike EMI planning India",
          "how much bike can I afford",
          "motorcycle budget India",
          "bike buying guide India"
        ]}
        path="/budget"
      />

      <div style={{ padding: "30px" }}>
        <h1>💰 Bike Budget Planner</h1>
        <p style={{ color: "#aaa", marginBottom: "20px" }}>
          Plan your bike purchase smartly based on your income and savings.
        </p>

        <input
          placeholder="Monthly Salary"
          value={salary}
          onChange={(e) => setSalary(e.target.value)}
          style={inputStyle}
        />

        <input
          placeholder="Down Payment"
          value={down}
          onChange={(e) => setDown(e.target.value)}
          style={inputStyle}
        />

        <button style={buttonStyle} onClick={calculate}>
          Check Budget
        </button>

        <div id="calculator-result">
          {result && (
            <>
              <h2 style={{ marginTop: "20px" }}>
                You can afford bike up to ₹ {result.toLocaleString("en-IN")}
              </h2>
              <button onClick={shareOnWhatsApp} 
                className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg text-sm">
                Share on WhatsApp
              </button>
              <button onClick={downloadPDF}
                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-sm">
                Download PDF
              </button>
            </>
          )}
        </div>

        <div style={{ marginTop: "40px", color: "#aaa", lineHeight: "1.8" }}>
          <h2>How to Decide Your Bike Budget in India</h2>
          <p>
            Buying a bike is an important financial decision. Your monthly salary,
            savings, and down payment play a major role in deciding how much you
            should spend on a motorcycle. A smart rule is to keep your EMI within
            a comfortable percentage of your income to avoid financial stress.
          </p>

          <p>
            With MotoHub India’s bike budget planner, you can quickly estimate
            the price range of bikes you can afford. This helps you shortlist
            motorcycles, compare options, and make better buying decisions.
          </p>

          <p>
            Whether you're planning to buy a commuter bike, sports bike, or
            premium motorcycle, proper budgeting ensures long-term affordability
            including fuel, maintenance, and insurance costs.
          </p>
        </div>
      </div>
    </>
  );
}

const inputStyle = {
  width: "100%",
  padding: "12px",
  marginBottom: "10px",
  borderRadius: "10px",
  background: "#1a1a1a",
  color: "#fff",
  border: "1px solid #333"
};

const buttonStyle = {
  width: "100%",
  padding: "12px",
  background: "linear-gradient(90deg,#ff4d00,#ff7a00)",
  border: "none",
  borderRadius: "10px",
  color: "#fff",
  cursor: "pointer"
};
